import React, { ReactElement, ReactNode } from "react";
import { Modal as AntModal, ModalProps as AntModalProps } from "antd";
import classNames from "classnames";
import Button from "@Components/Button";
import "./ModalConfirm.scss";
import { MODAL_SIZE } from "@Configs/enum";

export interface ModalCustomProps extends AntModalProps {
  children?: ReactNode;
  /**Name of apply button*/
  titleButtonApply?: string;

  typeButtonApply?: "primary" | "danger";

  /**Name of cancel button*/
  titleButtonCancel?: string;
  /**Cancel the form*/
  handleCancel?: (event: any) => void;
  /**Save the form*/
  handleSave?: (event: any) => void;
  /**Pass state of loading */
  icon?: ReactNode;

  title?: string;

  content?: string | ReactElement;

  showButtonCancel?: boolean;

  showButtonApply?: boolean;

  loadingButton?: boolean;
}

function ModalConfirm(props: ModalCustomProps) {
  const {
    titleButtonApply,
    titleButtonCancel,
    handleCancel,
    handleSave,
    icon,
    content,
    title,
    typeButtonApply = "danger",
    showButtonCancel = true,
    showButtonApply = true,
    loadingButton = false,
  } = props;

  const renderModalFooter = React.useMemo(
    () => (
      <div className={classNames("footer-modal")}>
        {showButtonCancel ? (<Button type="tertiary" onClick={handleCancel} loading={loadingButton} >
          <span>{titleButtonCancel ? titleButtonCancel : "Button Cancel"}</span>
        </Button>) : (<></>)}
        {showButtonApply ? (<Button type={typeButtonApply} onClick={handleSave} loading={loadingButton}>
          <span>{titleButtonApply ? titleButtonApply : "Button Apply"}</span>
        </Button>) : (<></>)}

      </div>
    ),
    [handleCancel, titleButtonCancel, handleSave, titleButtonApply, showButtonApply, showButtonCancel]
  );

  return (
    <>
      <AntModal
        {...props}
        centered
        className={classNames("modal-confirm__container", props?.className)}
        closeIcon={null}
        title=""
        footer={null}
        onCancel={handleCancel}
        width={MODAL_SIZE.SIZE_400}
      >
        <div className="modal_content">
          {icon}
          <span className="modal_content__title">{title}</span>
          {content && (
            <span className="modal_content__description">{content}</span>
          )}
          {props.children}
          <div className="modal_content__footer">{renderModalFooter}</div>
        </div>
      </AntModal>
    </>
  );
}

export default ModalConfirm;
